import { Mail, MailWarning } from "lucide-react";
import { fmtDate } from "@/lib/format";

export const EmailStatus = ({ doc }) => {
  const e = doc?.last_email;
  if (!e) return <span className="text-xs text-slate-500" data-testid="email-status">Aún no enviado por correo</span>;
  const ok = e.status === "enviado";
  const Icon = ok ? Mail : MailWarning;
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs ${ok ? "text-emerald-300" : "text-amber-300"}`} data-testid="email-status">
      <Icon className="w-3.5 h-3.5" />
      {ok ? `Enviado a ${e.to} el ${fmtDate(e.at)}${e.pdf ? " (con PDF)" : ""}` : `No enviado: ${e.error}`}
    </span>
  );
};
